import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-8 py-5 flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-purple-600" style={{ fontFamily: "'Pretendard', sans-serif" }}>
              온니잡
            </h1>
          </div>
          <a
            href="#pricing"
            className="px-7 py-2.5 bg-black text-white text-sm font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Pretendard', sans-serif" }}
          >
            시작하기
          </a>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-8 py-32 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gray-100 rounded-full mb-8">
            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-gray-700" style={{ fontFamily: "'Pretendard', sans-serif" }}>유흥업 전문 채용 플랫폼</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-6xl md:text-7xl font-bold text-gray-900 leading-tight mb-6" style={{ fontFamily: "'Pretendard', sans-serif", letterSpacing: '-0.03em' }}>
            사람 하나가<br />매출을 바꿉니다
          </h1>

          {/* Sub Headline */}
          <p className="text-xl text-gray-600 mb-12 leading-relaxed max-w-2xl mx-auto" style={{ fontFamily: "'Pretendard', sans-serif" }}>
            급할 때 바로 쓰는 채용 플랫폼<br />
            사장님 매장 운영 흐름에 맞게 설계되었습니다
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-16">
            <a
              href="#pricing"
              className="px-8 py-3.5 bg-black text-white text-base font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
              style={{ fontFamily: "'Pretendard', sans-serif" }}
            >
              지금 바로 써보기
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://pf.kakao.com/_xnxnxnxn"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3.5 bg-white border border-gray-300 text-gray-900 text-base font-semibold rounded-full hover:border-gray-400 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
              style={{ fontFamily: "'Pretendard', sans-serif" }}
            >
              <i className="ri-kakao-talk-fill text-yellow-500"></i>
              급구 상담하기
            </a>
          </div>

          {/* Hero Image */}
          <div className="relative max-w-5xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              {/* Image removed */}
            </div>
            {/* Floating Cards */}
            <div className="absolute -left-8 top-1/4 bg-white rounded-xl shadow-lg p-4 animate-float hidden md:block">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-user-add-line text-emerald-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500" style={{ fontFamily: "'Pretendard', sans-serif" }}>신규 지원자</p>
                  <p className="text-lg font-bold text-gray-900" style={{ fontFamily: "'Pretendard', sans-serif" }}>+24</p>
                </div>
              </div>
            </div>
            <div className="absolute -right-8 bottom-1/4 bg-white rounded-xl shadow-lg p-4 animate-float-delayed hidden md:block">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-blue-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500" style={{ fontFamily: "'Pretendard', sans-serif" }}>평균 채용 시간</p>
                  <p className="text-lg font-bold text-gray-900" style={{ fontFamily: "'Pretendard', sans-serif" }}>2.5시간</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float 3s ease-in-out infinite 1.5s;
        }
      `}</style>
    </section>
  );
}
